module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DHifvU/d2d_images/cover.jpg?1696093335971",
      "alt": "This image is the cover for the book De Heks uit de buurt"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("De Heks uit de buurt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Een vervloekte heks is van het eenzaamste soort. Verstoten door haar kleine gemeenschap, weet Henny Wilson dit heel goed. Voortdurend geplaagd door onevallen, houdt ze zich weg van mensen voor hun eigen veiligheid. Maar haar nieuwe buurman, Nathan, heeft andere ideeën. Hij gelooft dat de vloek in haar hoofd zit. Naarmate ze dichter bij elkaar groeien en er gevoelens ontwikkelen tussen hen, zweert Nathan aan Henny dat ze niet meer hoeft te lijden."), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      RK Moore, Raf Swiggers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("De Heks Uit De Buurt is gepubliceerd in september 2013, onder de pennaam RK Moore. Het boek is beschikbaar in zowel ebook als gedrukt formaat. Het is op dit moment vertaald in het Spaans en het Italiaans."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    RK Moore\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0